import { useMinimalCartUi } from 'features/cart/hooks/use-minimal-cart-ui';

import { useGetUserMinimalFavoritesQuery } from 'generated/graphql-gateway';
import { useAuthContext } from 'state/auth';

export const PreloadMinimalFavorites = () => {
  const { isAuthenticated } = useAuthContext();
  const enableMinimalCartUi = useMinimalCartUi();

  useGetUserMinimalFavoritesQuery({
    skip: !isAuthenticated || !enableMinimalCartUi,
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-first',
  });

  return null;
};
